import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    backgoround: theme.palette.primaryDark,
    width: "100%",
    display: "flex",
    flexDirection: "column",
    position: 'relative',
  },
  headerContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  buttonsContainer: {
    minWidth: "200px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
  },
  drawer: {
    backgroundColor: theme.palette.secondaryDark
  }
}));
